import { waLink, WA_MESSAGES } from "@/lib/whatsapp";

export default function WhatsAppButton() {
  return (
    <a
      data-testid="whatsapp-float-btn"
      href={waLink(WA_MESSAGES.general)}
      target="_blank"
      rel="noopener noreferrer"
      className="fixed bottom-5 right-5 md:bottom-6 md:right-6 z-40 flex items-center gap-2 rounded-full bg-[#25D366] px-4 py-3 md:px-5 md:py-3 text-sm font-medium text-white shadow-lg hover:shadow-xl transition-all hover:-translate-y-0.5"
      aria-label="Chat on WhatsApp"
    >
      <svg viewBox="0 0 24 24" className="h-5 w-5" fill="currentColor" aria-hidden="true">
        <path d="M20.52 3.48A11.91 11.91 0 0 0 12 0C5.37 0 0 5.37 0 12a11.93 11.93 0 0 0 1.65 6.05L0 24l6.11-1.6A11.94 11.94 0 0 0 12 24c6.63 0 12-5.37 12-12a11.88 11.88 0 0 0-3.48-8.52ZM12 21.82a9.8 9.8 0 0 1-5-1.37l-.36-.21-3.62.95.97-3.53-.23-.37A9.79 9.79 0 1 1 12 21.82Zm5.4-7.36c-.29-.15-1.74-.86-2-.96s-.47-.15-.66.15-.77.96-.94 1.16-.35.22-.65.07a7.94 7.94 0 0 1-2.35-1.45 8.83 8.83 0 0 1-1.63-2.03c-.17-.29 0-.45.13-.6.14-.14.29-.35.44-.52.15-.18.2-.3.3-.5.1-.2.05-.37-.02-.52-.07-.15-.66-1.58-.9-2.16-.23-.56-.48-.48-.66-.49h-.57a1.1 1.1 0 0 0-.8.37 3.34 3.34 0 0 0-1.04 2.48c0 1.46 1.07 2.87 1.22 3.07.14.2 2.11 3.22 5.12 4.52a17 17 0 0 0 1.71.63 4.14 4.14 0 0 0 1.89.12 3.1 3.1 0 0 0 2.03-1.43 2.52 2.52 0 0 0 .17-1.43c-.07-.12-.26-.2-.55-.34Z" />
      </svg>
      <span className="hidden sm:inline">Chat with us</span>
    </a>
  );
}
